/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Deep_P3Inputs */

const en_to_typescript_deep_p3 = /** @type {(inputs: To_Typescript_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nested objects are extracted into their own interfaces named after the key that held them, converted to PascalCase. A key named nested yields interface Nested, and the parent refers to it by name rather than inlining the shape. Two structurally identical objects under different keys therefore produce two interfaces rather than one shared one, so deduplicating them is a manual step if you care about it.`)
};

const ko_to_typescript_deep_p3 = /** @type {(inputs: To_Typescript_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 객체는 그것을 담고 있던 키의 이름을 PascalCase로 바꾼 자체 인터페이스로 추출됩니다. nested라는 키는 interface Nested를 만들고, 부모는 형태를 인라인으로 넣지 않고 이름으로 참조합니다. 따라서 서로 다른 키 아래 구조가 같은 두 객체는 공유되는 하나가 아니라 두 개의 인터페이스를 만들며, 중복 제거는 필요하다면 직접 해야 하는 단계입니다.`)
};

const ja_to_typescript_deep_p3 = /** @type {(inputs: To_Typescript_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたオブジェクトは、それを保持していたキーの名前を PascalCase にした独自インターフェースとして抽出されます。nested というキーは interface Nested を生み、親は形を埋め込まずに名前で参照します。したがって異なるキーの下にある構造的に同一な 2 つのオブジェクトは、共有された 1 つではなく 2 つのインターフェースを生み、重複の解消は気にするなら手作業の工程になります。`)
};

/**
* | output |
* | --- |
* | "Nested objects are extracted into their own interfaces named after the key that held them, converted to PascalCase. A key named nested yields interface Neste..." |
*
* @param {To_Typescript_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_deep_p3 = /** @type {((inputs?: To_Typescript_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_deep_p3(inputs)
	if (locale === "ko") return ko_to_typescript_deep_p3(inputs)
	return ja_to_typescript_deep_p3(inputs)
});